exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-users .b-table{min-width:1800px}.p-users .b-table td,.p-users .b-table th{font-size:.75rem}.p-users .b-table .td-user-coupons{overflow-x:scroll;white-space:pre;width:160px;padding:5px 0;box-sizing:border-box}.p-users .b-table .td-user-coupons>span{display:block;padding:4px 10px;color:#212529;font-size:.75rem;text-align:center;background-color:#dedede;border-radius:15px;margin-right:5px}.p-users .b-table .td-user-coupons>span:last-child{padding-right:15px}", ""]);

// exports
